/* eslint-disable no-plusplus */
/* eslint-disable no-mixed-operators */
export const saveToken = token => localStorage.setItem('sessionId', token);
export const getToken = () => localStorage.getItem('sessionId');

export const saveStore = storeId => localStorage.setItem('clientId', storeId);
export const getStore = () => localStorage.getItem('clientId');

export const clearLocalStorage = () => localStorage.clear();

const cpfValidator = (cpf) => {
  if (cpf === '00000000000'
    || cpf === '11111111111'
    || cpf === '22222222222'
    || cpf === '33333333333'
    || cpf === '44444444444'
    || cpf === '55555555555'
    || cpf === '66666666666'
    || cpf === '77777777777'
    || cpf === '88888888888'
    || cpf === '99999999999') return false;

  let add = 0;

  for (let i = 0; i < 9; i += 1) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let rev = 11 - (add % 11);

  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9))) return false;

  add = 0;

  for (let i = 0; i < 10; i += 1) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }

  rev = 11 - (add % 11);

  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10))) return false;

  return true;
};

const createCnpj = (cnpj) => {
  if (cnpj === '00000000000000'
    || cnpj === '11111111111111'
    || cnpj === '22222222222222'
    || cnpj === '33333333333333'
    || cnpj === '44444444444444'
    || cnpj === '55555555555555'
    || cnpj === '66666666666666'
    || cnpj === '77777777777777'
    || cnpj === '88888888888888'
    || cnpj === '99999999999999') {
    return false;
  }

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i -= 1) {
    soma += numeros.charAt(tamanho - i) * pos--;

    if (pos < 2) {
      pos = 9;
    }
  }

  const resultados = [0, 0];
  resultados[0] = soma % 11 < 2 ? 0 : 11 - soma % 11;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i -= 1) {
    soma += numeros.charAt(tamanho - i) * pos--;

    if (pos < 2) {
      pos = 9;
    }
  }

  resultados[1] = soma % 11 < 2 ? 0 : 11 - soma % 11;

  return resultados;
};

const cnpjValidator = (cnpj) => {
  const tamanho = cnpj.length - 2;
  const digitos = cnpj.substring(tamanho);
  const resultados = createCnpj(cnpj);

  if (resultados[0] !== parseInt(digitos.charAt(0), 10)) {
    return false;
  }

  if (resultados[1] !== parseInt(digitos.charAt(1), 10)) {
    return false;
  }

  return true;
};

export const cpfCnpjValidator = async (cpfCnpj) => {
  const formatedCpfCnpj = cpfCnpj.replace(/[^\d]+/g, '');

  if (formatedCpfCnpj.length === 11) { return cpfValidator(formatedCpfCnpj); }
  if (formatedCpfCnpj.length === 14) { return cnpjValidator(formatedCpfCnpj); }

  return false;
};
